import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { ComponentQuery } from 'models';
import { JSONHelpers } from 'helpers/JSONHelpers';

import { SearchService } from 'components/component-overview/services/SearchService';
import { useApplySearchQuery } from 'hooks/use-apply-search-query';

let lastAppliedQuery: string | null = null;
let lastAppliedSearchText: string | null = null;

const useSetFiltersFromQuery = () => {
    const searchParams = useSearchParams();

    const applySearchQuery = useApplySearchQuery({ acrossSite: true });

    useEffect(() => {
        const queryAsString = searchParams?.get('query');

        if (queryAsString && queryAsString !== lastAppliedQuery) {
            lastAppliedQuery = queryAsString;

            const query = JSONHelpers.parse<Partial<ComponentQuery>>(queryAsString);

            if (query) {
                SearchService.resetFilters();
                SearchService.mergeFilters(query);

                query.search && SearchService.setSearchBarQuery(query.search);
            }
        }
    }, [searchParams]);

    useEffect(() => {
        const searchText = searchParams?.get('searchText');

        if (searchText && searchText !== lastAppliedSearchText) {
            lastAppliedSearchText = searchText;

            SearchService.setSearchBarQuery(searchText);
            applySearchQuery(searchText);
        }
    }, [searchParams]);
};

export { useSetFiltersFromQuery };
